import React from "react";
import {ItemProductGift,  Item,  ItemHotDealLanding, ItemUsingSlide, ItemHotDealLandingUsingSlide, ItemProductGiftUsingSlide} from './Item';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

let responsiveproductlistmobile2 = {
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2
    }
  };
  let responsiveproductlistmobile3 = {
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 3
    }
  };
// layout 5
const Layout_1 =({item})=>{

    return(
        <div className="row bg-white mgt-5 product-list" id="">
            <ul className="row col-ul-1">
                {
                    item.length > 0 ? 
                    (
                        item.map((item, j)=>{
                           return <Item item={item} index={item.sku+j}/>
                        })
                    )
                    :
                    (null)
                }                
            </ul>
        </div>
    )
}
const Layout_2 =({item})=>{
    return(
        <div className="row bg-white mgt-5 product-list" id="">
            <ul className="row col-ul-1">
                {
                    item.length > 0 ? 
                    (
                        item.map((item, j)=>{
                           return <ItemHotDealLanding item={item} index={item.sku+j}/>
                        })
                    )
                    :
                    (null)
                } 
            </ul>
        </div>
    )
}

const Layout_3 =({item})=>{
    return(
        <div className="row bg-white mgt-5 product-list" id="">
            <ul className="row col-ul-1">
                {
                    item.length > 0 ? 
                    (
                        item.map((item, j)=>{
                           return <ItemProductGift item={item} index={item.sku+j}/>
                        })
                    )
                    :
                    (null)
                } 
            </ul> 
        </div>
    )
}
// layout 4,6

const Layout_4 =({item})=>{

    return(
        <div className="row bg-white mgx-0 product-list product-slider" id="">
            <ul className="row col-ul-2 mgx-0">
                {
                    item.length > 0 ? 
                    (
                        item.map((item, j)=>{
                           return <Item item={item} index={item.sku+j}/>
                        })
                    )
                    :
                    (null)
                }                
            </ul>
        </div>
    )
}
const Layout_5 =({item})=>{
    return(
        <div className="row bg-white mgt-5 product-list   product-slider" id="">
            <ul className="row col-ul-2 mgx-0">
                {
                    item.length > 0 ? 
                    (
                        item.map((item, j)=>{
                           return <ItemHotDealLanding item={item} index={item.sku+j}/>
                        })
                    )
                    :
                    (null)
                } 
            </ul>
        </div>
    )
}

const Layout_6 =({item})=>{
    return(
        <div className="row bg-white mgt-5 product-slider" id="product-list">
            <ul className="row col-ul-2 mgx-0">
                {
                    item.length > 0 ? 
                    (
                        item.map((item, j)=>{
                           return <ItemProductGift item={item} index={item.sku+j}/>
                        })
                    )
                    :
                    (null)
                } 
            </ul> 
        </div>
    )
}
// item slider
//layout 1,3
const Layout_7 =({item})=>{

    return(
        <div className="row bg-white mgx-0 product-list product-slider" id="">
             {
                 item.length>0?(
                    <Carousel key="product-layout-8"
                        responsive={responsiveproductlistmobile3}
                        >
                        {
                             item.map((item, j)=>{
                                return <ItemUsingSlide item={item} index={item.sku+j}/>
                             })
                        }
                    
                    </Carousel>
                ):(null)
            }
        </div>
    )
}
const Layout_8 =({item})=>{
    return(
        <div className="row bg-white mgx-0 product-list product-slider" id="">
            {
                 item.length>0?(
                    <Carousel key="product-layout-8"
                        responsive={responsiveproductlistmobile3}
                        >
                        {
                             item.map((item, j)=>{
                                return <ItemHotDealLandingUsingSlide item={item} index={item.sku+j}/>
                             })
                        }
                    
                    </Carousel>
                ):(null)
            }
        </div>
    )
}

const Layout_9 =({item})=>{
    return(
        <div className="row bg-white mgx-0 product-list product-slider" id="">
            {
                 item.length>0?(
                    <Carousel key="product-layout-9"
                        responsive={responsiveproductlistmobile3}
                        >
                        {
                             item.map((item, j)=>{
                                return <ItemProductGiftUsingSlide item={item} index={item.sku+j}/>
                             })
                        }
                    
                    </Carousel>
                ):(null)
            }
        </div>
    )
}
//layout 2
const Layout_10 =({item})=>{

    return(
        <div className="row bg-white mgx-0 product-list product-slider" id="">
             {
                 item.length>0?(
                    <Carousel key="product-layout-8"
                        responsive={responsiveproductlistmobile2}
                        >
                        {
                             item.map((item, j)=>{
                                return <ItemUsingSlide item={item} index={item.sku+j}/>
                             })
                        }
                    
                    </Carousel>
                ):(null)
            }
        </div>
    )
}
const Layout_11 =({item})=>{
    return(
        <div className="row bg-white mgx-0 product-list product-slider" id="">
            {
                 item.length>0?(
                    <Carousel key="product-layout-8"
                        responsive={responsiveproductlistmobile2}
                        >
                        {
                             item.map((item, j)=>{
                                return <ItemHotDealLandingUsingSlide item={item} index={item.sku+j}/>
                             })
                        }
                    
                    </Carousel>
                ):(null)
            }
        </div>
    )
}

const Layout_12 =({item})=>{
    return(
        <div className="row bg-white mgx-0 product-list product-slider" id="">
            {
                 item.length>0?(
                    <Carousel key="product-layout-9"
                        responsive={responsiveproductlistmobile2}
                        >
                        {
                             item.map((item, j)=>{
                                return <ItemProductGiftUsingSlide item={item} index={item.sku+j}/>
                             })
                        }
                    
                    </Carousel>
                ):(null)
            }
        </div>
    )
}
export {Layout_1,Layout_2, Layout_3, Layout_4,Layout_5, Layout_6, Layout_7,Layout_8, Layout_9, Layout_10,Layout_11, Layout_12}